import React from 'react';
import ButtonRender from './buttonRender';

const CButton = ({ content, askQuestion, ...props }) => {
  return (
    <ButtonRender
      content={content}
      isHistory={props.isHistory}
      askQuestion={askQuestion}
    />
  );
};

export default CButton;
